<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='pedidos' :items='pedidos' :search='search' sort-by='numeroPedido' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Pedidos
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog' scrollable persistent max-width='95%')
              template(v-slot:activator='{ on }')
                v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' v-on='on')
                  v-icon(dark) mdi-plus
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline {{ formTitle }}
                v-divider(light)
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense v-if="editedIndex === -1")
                            v-col(cols='12' sm='12' md='4')
                              v-autocomplete(:menu-props="{closeOnContentClick: true}" autocomplete="off" id="nombreCli" dense outlined :readonly='read' v-model='editedItem.idCliente' :items='clientes' label='Cliente')
                                template(v-slot:prepend-item v-if="validarCrearCli()")
                                  v-list(dense)
                                    v-list-item( @click='emp = true')
                                      v-list-item-avatar(color='grey_1' small)
                                        v-btn.mx-2(fab dark x-small color='success')
                                          v-icon(dark small) mdi-plus
                                      v-list-item-content
                                        v-list-item-title
                                          | Agregar Cliente
                            ClienteM(:dialog='emp' :editedIndex='-1' @close='emp = false' @save='listarClientes')
                          v-row(dense v-else)
                            v-col(cols='12' sm='12' md='4')
                              v-text-field(dense readonly outlined v-model='editedItem.idCliente.nombre'  label='Cliente')
                          v-row(dense)
                            v-col(cols='12' sm='12' md='4')
                              v-switch(dense color='success' :readonly='boton' v-model='editedItem.consignado' label='Pedido Consignado')
                              //- PRODUCTOS_A_SELECCIONAR
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              ProductosParaVenta(:read='read' :loading='loadinghijo' :consignado='editedItem.consignado' :productosParaVenta='productosParaVenta' @agregarAlCarrito='agregarAlCarrito')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              ProductosCargados(:read='read' :productosEnCarrito='editedItem.detalleProducto' @modificarCarrito='modificarCarrito' @quitarCarrito='quitarCarrito')

                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Montos
                        v-card-text
                          v-row(dense)
                            v-col(cols='6' sm='6' md='4')
                              v-text-field(dense readonly outlined :value='editedItem.gravado | read'  label='IVA')
                            v-col(cols='6' sm='6' md='4')
                              v-text-field(dense readonly outlined :value='editedItem.subTotal | read' label='Subtotal')
                            v-col(cols='8' sm='8' md='4')
                              v-text-field(dense readonly outlined :value='editedItem.total | read' label='Total + IVA')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(v-if="!read" color='success' small dark @click='save')
                    v-icon mdi-content-save
                    | Guardar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item,true)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(v-if='item.estatus === "generado" && validarModificar()' color='warning' @click='editItem(item, false)' v-on="on") mdi-pencil
            | Editar
          //- v-icon(v-if='item.estatus === "generado"'  color='red' @click='deleteItem(item)') mdi-delete
        template(v-slot:no-data)
          h1 No hay pedidos de compras asociadas
</template>

<script>
import Api from '@/services/methods'
import ProductosCargados from '../components/ProductosCargados'
import ProductosParaVenta from '../components/ProductosParaVenta'
import ClienteM from '../components/modals/ClienteM'
export default {
  name: 'Pedidos',
  data: () => ({
    peticion: false,
    dialog: false,
    read: false,
    boton: false,
    emp: false,
    loading: true,
    loadinghijo: true,
    headers: [
      { text: 'Número de Pedido', value: 'numeroPedido', align: 'center' },
      { text: 'Cliente', value: 'idCliente.nombre', align: 'center' },
      { text: 'Fecha de Registro', value: 'fechaRegistro', align: 'center' },
      { text: 'Monto Total', value: 'total', align: 'center' },
      { text: 'Estatus', value: 'estatus', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    search: '',
    permisosRuta: {},
    permisosCliente: {},
    pedidos: [],
    vendedores: [],
    clientes: [],
    productosParaVenta: [],
    editedIndex: -1,
    editedItem: {
      idCliente: '',
      consignado: false,
      detalleProducto: [],
      subTotal: 0,
      gravado: 0,
      total: 0
    },
    defaultItem: {
      idCliente: '',
      consignado: false,
      detalleProducto: [],
      subTotal: 0,
      gravado: 0,
      total: 0
    }
  }),

  components: {
    ProductosCargados,
    ProductosParaVenta,
    ClienteM
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Pedido' : this.read
        ? 'Informacion del Pedido'
        : 'Modificar Pedido'
    },
    formTitleShow () {
      return 'Información del Pedido'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
    this.permisosRuta = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'Pedido'
    )
    this.permisosCliente = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'Cliente'
    )
  },

  methods: {
    initialize () {
      this.listarPedidos()
      this.listarClientes()
      this.listarProductoParaVenta()
    },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },

    listarPedidos () {
      Api.get('pedido')
        .then(res => {
          this.pedidos = res.data
          this.pedidos.map(data => {
            data.fechaRegistro = this.formato(data.fechaRegistro)
            data.total = parseFloat(data.total);
            data.total = (data.total).toFixed(2);
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarClientes () {
      Api.get('cliente')
        .then(res => {
          res.data.map(cliente => {
            this.clientes.push({ text: cliente.nombre, value: cliente._id })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarProductoParaVenta () {
      Api.get('proalma/stock/all')
        .then(res => {
          this.loadinghijo = false
          this.productosParaVenta = res.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    actualizarMontosTotales () {
      // me actualizar los montos totales cuando se agrega un producto
      this.editedItem.subTotal = 0
      this.editedItem.gravado = 0
      this.editedItem.total = 0
      if (this.editedItem.detalleProducto.length > 0) {
        this.editedItem.detalleProducto.map(data => {
          this.editedItem.subTotal += data.subTotal
          this.editedItem.gravado += data.gravado
        })
        this.editedItem.total =
          Math.round(
            (this.editedItem.subTotal + this.editedItem.gravado) * 100
          ) / 100
      }
    },

    agregarAlCarrito (item) {
      this.boton = true
      const indexVenta = this.productosParaVenta.findIndex(
        prod => prod.idProducto === item.idProducto
      )
      const indexCarrito = this.editedItem.detalleProducto.findIndex(
        prod => prod.idProducto._id === item.idProducto._id
      )
      if (indexCarrito > -1) {
        this.editedItem.detalleProducto[indexCarrito].cantidadSolicitada +=
          item.cantidadSolicitada
        this.editedItem.detalleProducto[indexCarrito].total += item.total
        this.editedItem.detalleProducto[indexCarrito].total =
          Math.round(
            this.editedItem.detalleProducto[indexCarrito].total * 100
          ) / 100

        this.editedItem.detalleProducto = [...this.editedItem.detalleProducto]
      } else {
        this.editedItem.detalleProducto.push(item)
      }
      Object.assign(this.productosParaVenta[indexVenta], item)
      this.actualizarMontosTotales()
    },

    modificarCarrito (item) {
      const indexVenta = this.productosParaVenta.findIndex(prod => prod.idProducto._id === item.idProducto._id)
      item.cantidad = this.productosParaVenta[indexVenta].cantidad

      let producto = Object.assign({}, item)

      let suma = item.cantidad + item.cantidadSolicitada
      if (producto.cantidadSolicitadaAux > suma) {
        this.$swal({
          icon: 'error',
          title: 'La cantidad solicitada es mayor al stock',
          text: `cantidad solcitidad: ${producto.cantidadSolicitadaAux}, cantidad en stock: ${suma}`
        })
      } else {
        if (producto.cantidadSolicitadaAux < producto.cantidadSolicitada) {
          let dif = producto.cantidadSolicitada - producto.cantidadSolicitadaAux
          producto.cantidad += dif
          producto.cantidadSolicitada = producto.cantidadSolicitadaAux
        } else if (producto.cantidadSolicitadaAux === producto.cantidadSolicitada) {
        } else {
          producto.cantidad -= (producto.cantidadSolicitadaAux - producto.cantidadSolicitada)
          producto.cantidadSolicitada = parseInt(producto.cantidadSolicitada)
        }
      }

      const indexCarrito = this.editedItem.detalleProducto.findIndex(prod => prod.idProducto._id === item.idProducto._id)

      Object.assign(this.editedItem.detalleProducto[indexCarrito], producto)
      Object.assign(this.productosParaVenta[indexVenta], item)
      this.editedItem.detalleProducto = [...this.editedItem.detalleProducto]
      this.productosParaVenta = [...this.productosParaVenta]
      this.actualizarMontosTotales()
    },

    quitarCarrito (item) {
      const pos = this.editedItem.detalleProducto.indexOf(item)
      const indexVenta = this.productosParaVenta.findIndex(
        prod => prod.idProducto._id === item.idProducto._id
      )
      this.editedItem.detalleProducto.splice(pos, 1)
      this.productosParaVenta[indexVenta].cantidad += item.cantidadSolicitada
      this.actualizarMontosTotales()
      if (this.editedItem.detalleProducto.length > 0) this.boton = false
    },

    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },

    validarCrearCli () {
      return this.permisosCliente?.accion.includes('Crear')
    },

    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },

    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },

    editItem (item, bool) {
      this.editedIndex = this.pedidos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.read = bool
      this.boton = bool
    },

    deleteItem (item) {
      const index = this.pedidos.indexOf(item)
      confirm('¿Esta seguro que desea Eliminar?') &&
        this.pedidos.splice(index, 1)
      Api.delete('/pedido/' + item._id).then(response => {
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.productosParaVenta = []
        this.loadinghijo = true
        this.editedItem = Object.assign({}, this.defaultItem)
        // this.editedItem.detalleProducto = []
        this.editedIndex = -1
        this.read = false
        this.boton = false
        this.listarProductoParaVenta()
      }, 300)
    },

    validarCampos () {
      if (this.editedItem.idCliente === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },

    validaProductos () {
      if (this.editedItem.detalleProducto.length <= 0) {
        this.$swal({
          icon: 'error',
          title: 'No existen productos cargados',
          text: 'Carge productos para emitir el pedido'
        })
        return true
      }
      return false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    save () {
      if (!this.peticion && !this.validarCampos() && !this.validaProductos()) {
        this.peticion = true
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('pedido', this.editedItem)
            .then(response => {
              this.peticion = false
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Has actualizado una compra'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          Api.post('pedido', this.editedItem)
            .then(res => {
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Has actualizado una compra'
              })
              this.peticion = false
              this.close()
              this.initialize()
            })
            .catch(error => {
              this.peticion = false
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>
